import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LegalPages.css';

function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      {/* Top Navigation Bar */}
      <div className="legal-navbar">
        <div className="legal-navbar-container">
          <div className="legal-navbar-logo" onClick={() => navigate('/')}>
            <img src="/logo.svg" alt="S.C.A.L.P.E.L." />
          </div>
        </div>
      </div>

      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: December 30, 2025</p>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using S.C.A.L.P.E.L., you accept and agree to be bound by the terms and provision of this agreement.
            S.C.A.L.P.E.L. is operated by DocPlix Solutions Private Limited ("we," "us," or "our").
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Description of Service</h2>
          <p>
            S.C.A.L.P.E.L. is an AI-powered medical information chatbot designed to provide accurate medical information to
            support clinical decisions. The service is intended for use by healthcare professionals and is not a
            substitute for professional medical judgment.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use S.C.A.L.P.E.L. only for lawful purposes and in accordance with these Terms</li>
            <li>Provide accurate and complete information when using the service</li>
            <li>Maintain the confidentiality of your account credentials</li>
            <li>Not use the service to provide direct patient care without independent verification</li>
            <li>Not share, reproduce, or distribute content from S.C.A.L.P.E.L. without proper authorization</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Medical Disclaimer</h2>
          <p>
            S.C.A.L.P.E.L. provides general medical information and should not be used as a substitute for professional
            medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified
            health provider with any questions you may have regarding a medical condition.
          </p>
          <p>
            The information provided by S.C.A.L.P.E.L. is for educational and informational purposes only. We do not
            guarantee the accuracy, completeness, or usefulness of any information provided.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Intellectual Property</h2>
          <p>
            All content, features, and functionality of S.C.A.L.P.E.L., including but not limited to text, graphics, logos,
            and software, are owned by DocPlix Solutions Private Limited and are protected by international
            copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, DocPlix Solutions Private Limited shall not be liable for any
            indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability
            to use the service.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Data Privacy</h2>
          <p>
            Your use of S.C.A.L.P.E.L. is also governed by our Privacy Policy. Please review our Privacy Policy to understand
            our practices regarding the collection and use of your information.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Modifications to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify users of any material changes by
            posting the new Terms on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your access to S.C.A.L.P.E.L. immediately, without prior notice or
            liability, for any reason, including breach of these Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of India, without regard to
            its conflict of law provisions.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at:
          </p>
          <p className="contact-info">
            <strong>DocPlix Solutions Private Limited</strong><br />
            Email: <a href="mailto:contact@docplix.com">contact@docplix.com</a>
          </p>
        </section>
      </div>

      <div className="legal-footer">
        <p>&copy; 2025 DocPlix Solutions Private Limited. All rights reserved.</p>
      </div>
    </div>
  );
}

export default TermsPage;
